/* eslint-disable react/jsx-props-no-spreading */
import { type FC, type ChangeEvent } from "react";
import { useFormContext } from "react-hook-form";
import * as styles from "./styles.css";

type InputProps = {
  name: string;
  errorName?: string;
  placeholder: string;
  max?: number;
  min?: number;
  requiredErrorMessage?: string;
  isError?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const NumberField: FC<InputProps> = ({
  name,
  errorName,
  placeholder,
  max,
  min,
  requiredErrorMessage,
  isError,
  onChange,
}) => {
  const { register, clearErrors } = useFormContext();
  const deleteErrorMessage = () => {
    if (errorName) {
      clearErrors(errorName);
    } else {
      clearErrors(name);
    }
  };
  return (
    <input
      type="number"
      inputMode="numeric"
      max={max}
      min={min}
      placeholder={placeholder}
      className={styles.input({ isError })}
      {...register(name, {
        required: requiredErrorMessage,
        onChange: (e: ChangeEvent<HTMLInputElement>) => {
          if (onChange) onChange(e);
          deleteErrorMessage();
        },
      })}
    />
  );
};
